export enum SmsSendButtonTitleEnum {
    TITLE_1 = 'Poslat SMS kód',
    TITLE_2 = 'Poslat nový sms kód',
}
